import {connect} from 'react-redux';
import {getStudentInformation} from 'shared/actions/student';
import MicroScholarshipsList from './micro-scholarships-list';
import {fetchOpportunityCards} from 'shared/micro-scholarships/actions/opportunity-cards';
import {setNavigationAnnouncement} from 'shared/actions/accessibility-announcement';

export default connect(null, {
  getStudentInformation,
  fetchOpportunityCards,
  setNavigationAnnouncement,
})(MicroScholarshipsList);
